export class IterationData {
    index: number;
    itemCount: number;
    subscriptionId: string;
  }
